<template>
  <div class="tomb-display-page">
    <!-- 头部导航组件 -->
    <HeaderNav />

    <!-- 统一的顶部装饰和图片 -->
    <div class="box_1-spacer flex-col"></div>
    <div class="box_2 flex-col"></div>
    <div class="banner-wrapper">
      <img 
        class="banner-img" 
        :src="getImageUrl(siteConfig?.config?.['pic_墓型'] || siteConfig?.config?.['pic_墓型展示']) || '/files/images/M5.jpg'" 
        alt="Tomb Display Banner" 
        referrerpolicy="no-referrer" 
      />
    </div>

    <!-- Section: Tomb Types (墓型展示) -->
    <div class="section-tomb container">
      <div class="news-content flex-col">
        <div class="news-header flex-col">
          <h1 class="news-title">墓型展示</h1>
          <p class="news-subtitle">TOMB TYPE DISPLAY</p>
        </div>
      </div>

      <div class="tomb-intro">
        <div class="intro-card-img">
          <img src="./assets/img/b8d1de1429bf7e0ab1edbd874da9888e.png" alt="intro" />
        </div>
        <div class="intro-card-text">
          <h3>一碑一故事，一墓一人生的高端艺术墓区</h3>
          <p>A high-end art cemetery where each tombstone tells a story and each grave represents a life.</p>
        </div>
      </div>

      <!-- Tomb List -->
      <div class="landscape-grid" v-if="shapesList.length > 0">
        <div 
          v-for="item in shapesList" 
          :key="item.id"
          class="landscape-card"
        >
          <div class="card-image-box">
            <img
              v-if="item.cover"
              :src="getImageUrl(item.cover)"
              :alt="item.title"
              class="card-img"
              referrerpolicy="no-referrer"
            />
          </div>
          <div class="card-title">{{ item.title }}</div>
        </div>
      </div>

      <div v-if="loading" class="loading-wrapper">
        <p>加载中...</p>
      </div>

      <div v-if="!loading && shapesList.length === 0" class="empty-wrapper">
        <p>暂无墓型数据</p>
      </div>
    </div>

    <!-- Footer: ContactUsSection -->
    <ContactUsSection />
  </div>
</template>

<script>
import HeaderNav from '@/components/HeaderNav.vue';
import ContactUsSection from '@/components/ContactUsSection.vue';
import { getShapeList, getSiteConfig } from '@/api/home';
import { getImageUrl } from '@/config/api';

export default {
  name: 'TombDisplayPage',
  components: {
    HeaderNav,
    ContactUsSection
  },
  data() {
    return {
      shapesList: [],
      loading: false,
      siteConfig: null
    };
  },
  mounted() {
    this.fetchShapes();
    this.fetchSiteConfig();
  },
  methods: {
    // 获取墓型列表
    async fetchShapes() {
      this.loading = true;
      try {
        const res = await getShapeList();
        console.log('fetchShapes 响应:', res);
        if (res.code === 0 && res.data) {
          // 新接口返回的数据结构: { data: { list: [...] } }
          if (res.data.list && Array.isArray(res.data.list)) {
            this.shapesList = res.data.list;
          } else if (Array.isArray(res.data)) {
            this.shapesList = res.data;
          }
          console.log('更新 shapesList:', this.shapesList);
        }
      } catch (error) {
        console.error('获取墓型列表失败:', error);
      } finally {
        this.loading = false;
      }
    },
    // 获取网站配置
    async fetchSiteConfig() {
      try {
        const res = await getSiteConfig();
        if (res.code === 0 && res.data && res.data.config) {
          this.siteConfig = res.data;
        }
      } catch (error) {
        console.error('获取网站配置失败:', error);
      }
    },
    getImageUrl(imgPath) {
      return getImageUrl(imgPath);
    }
  }
};
</script>

<style scoped>
/* Global Container */
.tomb-display-page {
  width: 100%;
  min-height: 100vh;
  background-color: #fff;
  overflow-x: hidden;
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

/* 
   Section: Banner 
*/
.box_1-spacer {
  background-color: rgba(255, 255, 255, 1) !important;
  width: 100% !important;
  max-width: 1920px !important;
  height: auto !important;
  min-height: 100px !important;
  margin: 0 auto !important;
  box-sizing: border-box !important;
}

.box_2 {
  background-color: rgba(0, 149, 151, 1) !important;
  width: 100% !important;
  max-width: 36px !important;
  height: 4px !important;
  margin: 50px auto 0 !important;
  box-sizing: border-box !important;
}

.banner-wrapper {
  width: 100% !important;
  max-width: 1918px !important;
  height: auto !important;
  min-height: 398px !important;
  margin: -53px auto 0 !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
}

.banner-img {
  width: 100% !important;
  max-width: 1918px !important;
  height: auto !important;
  min-height: 398px !important;
  margin: 0 auto !important;
  display: block !important;
  object-fit: cover !important;
  box-sizing: border-box !important;
}

/* 
   Section: Tomb Display (墓型展示)
*/
.section-tomb {
  margin: 60px auto;
}

/* 新闻内容区域 - 自适应 */
.news-content {
  width: 100% !important;
  max-width: 1200px !important;
  margin: 42px auto 0 !important;
  padding: 40px 20px !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: column !important;
}

.news-header {
  width: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  margin-bottom: 50px !important;
  padding-bottom: 30px !important;
  border-bottom: 2px solid rgba(0, 149, 151, 0.2) !important;
  box-sizing: border-box !important;
}

.news-title {
  width: auto !important;
  height: auto !important;
  font-size: clamp(28px, 4vw, 36px) !important; /* 响应式字体 */
  font-weight: bold !important;
  color: rgba(0, 149, 151, 1) !important;
  margin: 0 0 10px 0 !important;
  text-align: center !important;
  line-height: 1.2 !important;
}

.news-subtitle {
  width: auto !important;
  height: auto !important;
  font-size: clamp(14px, 1.5vw, 18px) !important; /* 响应式字体 */
  color: #666 !important;
  margin: 0 !important;
  text-align: center !important;
  letter-spacing: 2px !important;
  line-height: 1.2 !important;
}

.section-header {
  text-align: center;
  margin-bottom: 40px;
}

.header-main {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 10px;
}

.header-deco {
  width: 300px;
  height: auto;
}

.header-title {
  font-family: STKaitiSC-Black;
  font-size: 32px;
  color: #333;
  margin: 0;
}

.header-sub {
  font-family: Arial;
  font-size: 14px;
  color: #999;
  letter-spacing: 2px;
}

.tomb-intro {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
  margin-bottom: 40px;
  text-align: left;
}

.intro-card-img img {
  width: 200px;
  height: auto;
}

.intro-card-text h3 {
  font-size: 18px;
  color: #8c3000;
  margin-bottom: 10px;
  font-family: STKaitiSC-Black;
}

.intro-card-text p {
  font-size: 12px;
  color: #999;
  max-width: 300px;
}

.landscape-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 30px;
}

.landscape-card {
  display: flex;
  flex-direction: column;
  background: #f9f9f9;
  transition: transform 0.3s ease;
}

.landscape-card:hover {
  transform: translateY(-5px);
}

.card-image-box {
  width: 100%;
  aspect-ratio: 4/3;
  overflow: hidden;
}

.card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-title {
  padding: 15px;
  text-align: center;
  font-size: 16px;
  color: #5c5c5c;
  font-family: STKaitiSC-Regular;
  background-color: #fff;
  border-top: 1px solid #eee;
}

.loading-wrapper,
.empty-wrapper {
  text-align: center;
  padding: 40px;
  color: #999;
}

/* Mobile Adaptation */
@media (max-width: 992px) {
  .landscape-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .header-deco {
    width: 50px;
    height: auto;
  }
}

@media (max-width: 768px) {
  .box_1-spacer {
    min-height: 80px !important;
  }

  .box_2 {
    margin: 30px auto 0 !important;
  }

  .banner-wrapper {
    margin: -40px auto 0 !important;
    min-height: 300px !important;
  }

  .banner-img {
    min-height: 300px !important;
  }

  .news-content {
    padding: 30px 15px !important;
    margin: 30px auto 0 !important;
  }

  .news-header {
    margin-bottom: 30px !important;
    padding-bottom: 20px !important;
  }

  .tomb-intro {
    flex-direction: column;
    text-align: center;
    gap: 10px;
  }
  
  .intro-card-text p {
    margin: 0 auto;
  }

  .landscape-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 480px) {
  .header-title {
    font-size: 24px;
  }
  
  .header-deco {
    width: 30px;
  }

  .landscape-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>

